import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetServiceMessageRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetServiceMessageResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getServiceMessage = (request: GetServiceMessageRequest, options?: CashRequestOptions) =>
  post<GetServiceMessageRequest, GetServiceMessageResponse>('/2.0/cash/get-service-message', request, {
    ...options,
    rejectOnError: true,
  })
